import type { IFilter } from '../model/engagementFilter';

export const isQueryEnabled = (filter: IFilter) => {
  return filter.maxTimeCreated || filter.minTimeCreated
    ? !!filter.maxTimeCreated && !!filter.minTimeCreated
    : true;
};
